module.exports = __webpack_public_path__ + "img/wild-rag-deck-04.cc732230.jpeg";